module.exports = __webpack_public_path__ + "static/media/degree-xl.0c943a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/degree-xl.jpg
// module id = 407
// module chunks = 13